import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue' 
import StaffDashboard from '../components/StaffDashboard.vue'
import PatientManagement from '../components/PatientManagement.vue'
import StaffManagement from '../components/StaffManagement.vue'
import PatientAnalytics from '../components/PatientAnalytics.vue'
import PatientProfile from '../components/PatientProfile.vue'

Vue.use(VueRouter)

const routes = [
  { 
    path: '/login', 
    name: 'Login',
    component: Login,
    meta: { 
      guest: true,
      title: 'Login | Palmiges Portal' 
    }
  },
  { 
    path: '/dashboard', 
    name: 'Dashboard', 
    component: StaffDashboard,
    meta: { 
      requiresAuth: true,
      title: 'Dashboard | Palmiges Portal' 
    }
  },
  { 
    path: '/patients', 
    name: 'Patients', 
    component: PatientManagement,
    meta: { 
      requiresAuth: true,
      title: 'Patients | Palmiges Portal' 
    }
  },
  {
    path: '/staff',
    name: 'Staff',
    component: StaffManagement,
    meta: { 
      requiresAuth: true,
      title: 'Staff Management | Palmiges Portal' 
    }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: PatientAnalytics,
    meta: { 
      requiresAuth: true,
      title: 'Patient Analytics | Palmiges Portal' 
    }
  },
  {
    path: '/patients/:id', 
    name: 'PatientProfile',
    component: PatientProfile,
    meta: { 
      requiresAuth: true,
      title: 'Patient Profile | Palmiges Portal' 
    }
  },
  { path: '*', redirect: '/login' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// ✅ NAVIGATION GUARD (Auth + Tab Titles)
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('user-token');

  // --- 1. SET BROWSER TAB TITLE ---
  // This looks at the 'title' property in the meta tags defined above
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else {
    document.title = 'Palmiges Portal'; // Default fallback
  }

  // --- 2. AUTHENTICATION LOGIC ---
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login');
  } 
  else if (to.matched.some(record => record.meta.guest) && isAuthenticated) {
    next('/dashboard');
  } 
  else {
    next();
  }
});

export default router